import React from 'react';
import { aloSidebarExample } from './codeExamples';
import AloSidebar from '../_shared/ui-components/YogaUI/alo-ui/AloSidebar';

const AloSidebarExample = () => {
  const [visible, setVisible] = React.useState(false);
  const [anchor, setAnchor] = React.useState<'top' | 'right' | 'bottom' | 'left'>('right');
  const [desktopWidth, setDesktopWidth] = React.useState(560);
  const [mobileWidth, setMobileWidth] = React.useState(400);
  const [headerBorder, setHeaderBorder] = React.useState(true);
  return (
    <div className="items column mb-2xl">
      <div>
        <p className="editorial-large semibold mb-md">AloSidebar</p>
      </div>
      <div className="section">
        <h6 style={{ width: 100, margin: 0 }}>Options:</h6>
      </div>
      <div className="section">
        <p className="body" style={{ width: 100, margin: 0 }}>
          headerBorder:
        </p>
        <div className="yoga-ui-checkbox">
          <input
            id="headerBorder"
            type="checkbox"
            checked={headerBorder}
            onClick={() => setHeaderBorder(!headerBorder)}
          />
          <label htmlFor="headerBorder">headerBorder</label>
        </div>
      </div>
      <div className="flex-wrap section">
        <p className="body" style={{ width: 100, margin: 0 }}>
          anchor:
        </p>
        <div className="yoga-ui-checkbox">
          <input id="topAnchor" type="checkbox" checked={anchor === 'top'} onClick={() => setAnchor('top')} />
          <label htmlFor="topAnchor">top</label>
        </div>

        <div className="yoga-ui-checkbox">
          <input id="rightAnchor" type="checkbox" checked={anchor === 'right'} onClick={() => setAnchor('right')} />
          <label htmlFor="rightAnchor">right</label>
        </div>

        <div className="yoga-ui-checkbox">
          <input id="bottomAnchor" type="checkbox" checked={anchor === 'bottom'} onClick={() => setAnchor('bottom')} />
          <label htmlFor="bottomAnchor">bottom</label>
        </div>

        <div className="yoga-ui-checkbox">
          <input id="leftAnchor" type="checkbox" checked={anchor === 'left'} onClick={() => setAnchor('left')} />
          <label htmlFor="leftAnchor">left</label>
        </div>
      </div>
      <div className="section">
        <p className="body" style={{ width: 100, margin: 0 }}>
          desktopWidth:
        </p>
        <div className="yoga-ui-text-input">
          <input
            type="number"
            id="desktopWidth"
            className="yoga-ui-input"
            placeholder="desktop width"
            value={desktopWidth}
            onChange={(event) => setDesktopWidth(Number(event.target.value))}
          />
          <label htmlFor="desktopWidth">desktop width</label>
        </div>
      </div>
      <div className="section">
        <p className="body" style={{ width: 100, margin: 0 }}>
          mobileWidth:
        </p>
        <div className="yoga-ui-text-input">
          <input
            type="number"
            id="mobileWidth"
            className="yoga-ui-input"
            placeholder="desktop width"
            value={mobileWidth}
            onChange={(event) => setMobileWidth(Number(event.target.value))}
          />
          <label htmlFor="mobileWidth">mobile width</label>
        </div>
      </div>
      <div className="section mt-5">
        <button className="button-primary" onClick={() => setVisible(true)}>
          Open Sidebar
        </button>
        <AloSidebar
          title="simple alosidebar"
          headerBorder={headerBorder}
          visible={visible}
          onClose={() => setVisible(false)}
          desktopWidth={desktopWidth}
          mobileWidth={mobileWidth}
          anchor={anchor}
        >
          <div>
            <h5 style={{ textAlign: 'center', marginTop: '1rem' }}>This is test sidebar</h5>
          </div>
        </AloSidebar>
      </div>
      <div>
        <pre>{aloSidebarExample}</pre>
      </div>
    </div>
  );
};

export default AloSidebarExample;
